import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

import ToothGraphic5 from '@/assets/images/Tooth-graphic-5.svg'
import { isNullorEmpty } from '@/utils'

function FrameworkPDF({ recipe, frameworkIndex }) {
  if (
    recipe.provided_input.indication === 'Veneer on refractory' ||
    recipe.provided_input.indication === 'PFM Crown'
  ) {
    return null
  }

  const advice = recipe.internallayer_advice[frameworkIndex]

  return (
    <Paper
      id="download-page-0"
      elevation={0}
      sx={{
        backgroundColor: '#FFF',
        px: 5,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexGrow: 1,
      }}
    >
      <Grid container sx={{ height: '100%' }}>
        {/* Left Side */}
        <Grid item xs={4} sx={{ backgroundColor: 'white' }}>
          <Box
            component="img"
            src={ToothGraphic5}
            alt="Toothimage"
            sx={{ width: '233px', height: '330px' }}
          />
        </Grid>

        {/* Right Side */}
        <Grid
          item
          xs={8}
          container
          direction="column"
          sx={{ backgroundColor: '#f8f9fa', flexGrow: 1 }}
        >
          {/* Framework Details */}
          <Box display="flex" alignItems="center" m={2}>
            <Typography
              variant="h5"
              component="div"
              sx={{ marginRight: 2, color: 'black' }}
            >
              Framework:
            </Typography>
            {isNullorEmpty(advice, 'capbrand') && (
              <Box
                sx={{
                  backgroundColor: '#F44336',
                  borderRadius: '16px',
                  padding: '8px',
                  color: 'black',
                  marginLeft: 1,
                }}
              >
                {advice?.capbrand}
              </Box>
            )}
            {isNullorEmpty(advice, 'substructurename') && (
              <Box
                sx={{
                  backgroundColor: '#F44336',
                  borderRadius: '16px',
                  padding: '8px',
                  color: 'black',
                  marginLeft: 1,
                }}
              >
                {advice?.substructurename}
              </Box>
            )}
          </Box>

          {/* Table Section */}
          <Box sx={{ px: 5, flexGrow: 1 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ fontWeight: 'bold', color: 'black' }}
                  ></TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>
                    Cervical
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>
                    Middle
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>
                    Incisal
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Thickness Row */}
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>
                    Thickness
                  </TableCell>
                  <TableCell sx={{ color: 'black' }}>
                    {isNullorEmpty(advice, 'thickness_cervical')
                      ? `${advice?.thickness_cervical?.toFixed(2)} mm`
                      : '-'}
                  </TableCell>
                  <TableCell sx={{ color: 'black' }}>
                    {isNullorEmpty(advice, 'thickness_middle')
                      ? `${advice?.thickness_middle?.toFixed(2)} mm`
                      : '-'}
                  </TableCell>
                  <TableCell sx={{ color: 'black' }}>
                    {isNullorEmpty(advice, 'thickness_incisal')
                      ? `${advice?.thickness_incisal?.toFixed(2)} mm`
                      : '-'}
                  </TableCell>
                </TableRow>

                {/* Staining Row */}
                {advice?.staining ? (
                  <>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>
                        Estimated required staining
                      </TableCell>
                      <TableCell sx={{ color: 'black' }}>
                        {isNullorEmpty(
                          advice,
                          'stainingdelLAB_cervical',
                          '1',
                        ) ? (
                          <>
                            &Delta;A
                            {advice?.stainingdelLAB_cervical[1]?.toFixed(2)}
                          </>
                        ) : (
                          '-'
                        )}
                        {isNullorEmpty(
                          advice,
                          'stainingdelLAB_cervical',
                          '2',
                        ) ? (
                          <>
                            &Delta;B
                            {advice?.stainingdelLAB_cervical[2]?.toFixed(2)}
                          </>
                        ) : (
                          '-'
                        )}
                      </TableCell>
                      <TableCell sx={{ color: 'black' }}>
                        {isNullorEmpty(advice, 'stainingdelLAB_middle', '1') ? (
                          <>
                            &Delta;A
                            {advice?.stainingdelLAB_middle[1]?.toFixed(2)}
                          </>
                        ) : (
                          '-'
                        )}
                        {isNullorEmpty(advice, 'stainingdelLAB_middle', '2') ? (
                          <>
                            &Delta;B
                            {advice?.stainingdelLAB_middle[2]?.toFixed(2)}
                          </>
                        ) : (
                          '-'
                        )}
                      </TableCell>
                      <TableCell sx={{ color: 'black' }}>
                        {isNullorEmpty(
                          advice,
                          'stainingdelLAB_incisal',
                          '1',
                        ) ? (
                          <>
                            &Delta;A
                            {advice?.stainingdelLAB_incisal[1]?.toFixed(2)}
                          </>
                        ) : (
                          '-'
                        )}
                        {isNullorEmpty(
                          advice,
                          'stainingdelLAB_incisal',
                          '2',
                        ) ? (
                          <>
                            &Delta;B
                            {advice?.stainingdelLAB_incisal[2]?.toFixed(2)}
                          </>
                        ) : (
                          '-'
                        )}
                      </TableCell>
                    </TableRow>

                    {/* Staining Brand */}
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>
                        Staining brand
                      </TableCell>
                      <TableCell sx={{ color: 'black' }}>
                        {advice?.stain_cervical || '-'}
                      </TableCell>
                      <TableCell sx={{ color: 'black' }}>
                        {advice?.stain_middle || '-'}
                      </TableCell>
                      <TableCell sx={{ color: 'black' }}>
                        {advice?.stain_incisal || '-'}
                      </TableCell>
                    </TableRow>

                    {/* VITA3D */}
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>
                        Estimated required staining in VITA3D
                      </TableCell>
                      <TableCell sx={{ color: 'black' }}>
                        {advice?.VITAafterstaining_cervical || '-'}
                      </TableCell>
                      <TableCell sx={{ color: 'black' }}>
                        {advice?.VITAafterstaining_middle || '-'}
                      </TableCell>
                      <TableCell sx={{ color: 'black' }}>
                        {advice?.VITAafterstaining_incisal || '-'}
                      </TableCell>
                    </TableRow>
                  </>
                ) : (
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>
                      Estimated required staining
                    </TableCell>
                    <TableCell colSpan={3} sx={{ color: 'black' }}>
                      {advice?.instructions ||
                        'There is no need to stain the framework, you can start with layering.'}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </Grid>
      </Grid>

      {/* Divider */}
      <Box
        component="hr"
        sx={{
          backgroundColor: 'black',
          opacity: 1,
          margin: 0,
          border: 0,
          height: '1px',
        }}
      />
    </Paper>
  )
}

export default FrameworkPDF
